import { Badge } from '@/components/ui/Badge'
import {
  Card,
  CardDescription,
  CardHeader,
  CardList,
  CardListRow,
  CardTitle,
} from '@/components/ui/Card'
import { AvatarCell } from '@/components/shared'
import type { Transaction } from '@/models'

interface TransactionsListProps {
  transactions: readonly Transaction[]
}

export function TransactionsList({ transactions }: TransactionsListProps) {
  return (
    <Card>
      <CardHeader>
        <div className="min-w-0">
          <CardTitle>Recent Transactions</CardTitle>
          <CardDescription>Newest first.</CardDescription>
        </div>
      </CardHeader>

      <CardList className="max-h-130 overflow-y-auto overscroll-contain">
        {transactions.map((transaction) => (
          <CardListRow key={transaction.id}>
            <AvatarCell name={transaction.player} />
            <span className="min-w-0 flex-1">
              <span className="text-fg block truncate text-sm font-semibold">
                {transaction.player}
              </span>
              <span className="text-fg-subtle block truncate text-xs">{transaction.pack}</span>
            </span>
            <Badge variant="outline" size="tag" className="shrink-0">
              {transaction.channel}
            </Badge>
            <span className="text-fg shrink-0 text-sm font-semibold tabular-nums">
              {transaction.amount}
            </span>
            <span className="text-fg-subtle shrink-0 text-xs tabular-nums">{transaction.ago}</span>
          </CardListRow>
        ))}
      </CardList>
    </Card>
  )
}
